<template>
  <v-row v-if="reports.length" class="mt-2">
    <v-col cols="12">
      <div class="subtitle-1 font-weight-medium">Reportes iTPV 3.0</div>
      <div class="caption grey--text">Réplica de los reportes del punto de venta clásico.</div>
    </v-col>
    <v-col v-for="report in reports" :key="report.id" cols="12" md="6" lg="4">
      <v-card outlined hover class="legacy-report-card" @click="openReport(report)">
        <v-card-title class="d-flex align-center">
          <v-icon color="primary" class="mr-2">{{ report.icon || 'mdi-file-chart-outline' }}</v-icon>
          {{ report.title }}
        </v-card-title>
        <v-card-text>{{ report.description }}</v-card-text>
        <v-card-actions>
          <v-btn text color="primary">
            Abrir reporte
            <v-icon right>mdi-arrow-right</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { fetchReportsCatalog } from '@/services/legacyReportsService';

/**
 * Tarjetas de reportes legacy iTPV 3.0 filtradas por grupo
 * (customers | inventory | sales). Se usan en las secciones de reportes.
 */
export default {
  name: 'LegacyReportsGroupCards',
  props: {
    group: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      reports: [],
    };
  },
  async mounted() {
    try {
      const catalog = await fetchReportsCatalog();
      this.reports = (catalog.reports || []).filter((report) => report.group === this.group);
    } catch (error) {
      console.error('Error cargando catálogo de reportes legacy:', error);
    }
  },
  methods: {
    openReport(report) {
      this.$router.push({ name: 'AdminLegacyReportViewer', params: { reportId: report.id } });
    },
  },
};
</script>

<style scoped>
.legacy-report-card {
  cursor: pointer;
}
</style>
